import watchAcceptReservationSaga from './acceptReservation';
import watchCancelReservationSaga from './cancelReservation';
import watchConfirmReservationSaga from './confirmReservation';
import watchCreateReservationSaga from './createReservation';
import watchFetchReservationsSaga from './fetchReservations';
import watchGuestArrivedSaga from './guestArrived';
import watchRequestReservationAnswerSaga from './realTimeReservationAnswer';
import watchRejectReservationSaga from './rejectReservation';
import watchResolveReservationSaga from './resolveReservation';
import watchUpdateReservationSaga from './updateReservation';
import watchUpdateReservationGuestSaga from './updateReservationGuest';
import watchUpdateReservationStateSaga from './updateReservationState';

const reservationSagas = [
  watchAcceptReservationSaga(),
  watchFetchReservationsSaga(),
  watchCreateReservationSaga(),
  watchUpdateReservationGuestSaga(),
  watchUpdateReservationSaga(),
  watchCancelReservationSaga(),
  watchRejectReservationSaga(),
  watchResolveReservationSaga(),
  watchUpdateReservationStateSaga(),
  watchGuestArrivedSaga(),
  watchRequestReservationAnswerSaga(),
  watchConfirmReservationSaga(),
];
export default reservationSagas;
